module.exports = __webpack_public_path__ + "static/media/customer-1.b56b4351.jpg";